import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import { Message } from 'element-ui'
export const constantRoutes = [
	{
		path: '/redirect',
		component: Layout,
		hidden: true,
		children: [
			{
				path: '/redirect/:path(.*)',
				component: () => import('@/views/login/index')
			}
		]
	},
	{
		path: '/',
		component: () => import('@/views/login/index'),
		redirect: '/login',
		hidden: true
	},
	{
		name: 'login',
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/agreementInfos',
		component: () => import('@/views/agreementInfos/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/error-page/404'),
		hidden: true
	},
	{
		path: '/401',
		component: () => import('@/views/error-page/401'),
		hidden: true
	},
	{
		path: '/backweapp',
		component: () => import('@/views/backweapp')
	}
]

export const asyncRoutes = [
	{
		path: '/homePage',
		component: Layout,
		redirect: '/homePage',
		name: 'homePage',
		children: [
			{
				path: 'homePage',
				component: () => import('@/views/homePage/index2'),
				name: 'homePage',
				meta: {
					title: '首页',
					icon: {
						normal: 'iconfont icon-homefill'
					},
					affix: true
				}
			}
		]
	},
	{ path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
	new Router({
		mode: 'hash',
		scrollBehavior: () => ({ y: 0 }),
		routes: constantRoutes
	})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}
export default router
